// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy } from './shared';

export const label = 'Contents - Personal Possessions';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C12/789653218',
  policyDetailsId: '121234737781',
  forename: 'Albert',
  coverType: 'Contents',
  accidentalDamageLevel: { Buildings: 'Basic', Contents: 'Full' },
  personalPossessionsSumInsured: 550
});
